import { TOKEN_KEY_NAME } from '@/app-config';

export type Token = string;

export const getToken = (): Token => {
  const token = localStorage.getItem(TOKEN_KEY_NAME);
  return token ?? '';
};

export const saveToken = (token: Token) => {
  localStorage.setItem(TOKEN_KEY_NAME, token);
};

export const deleteToken = () =>
  localStorage.removeItem(TOKEN_KEY_NAME);
